import { filter, find, findIndex } from 'lodash';
import { observable, action, makeObservable } from 'mobx'
import IImage from '../interfaces/IImage';

export default class ImageStore {

     list: IImage[] = [];

    addRecords(records: IImage[]): any {
        if (records.length > 0) {
            records.forEach((record: IImage) => this.addRecord(record));
        }
    }

    private addRecord(record: IImage) {
        if (!record) {
            return;
        }

        const index = findIndex(this.list, { id: record.id });
        if (index >= 0) {
            this.list.splice.apply(this.list, [index, 1, record]);
        } else {
            this.list.push(record);
        }
    }

    public getById(id: string): IImage {
        return find(this.list, { id: id });
    }

    public getByIds(ids: string[]): IImage[] {
        return filter(this.list, item => {
            if (ids.includes(item.id)) {
                return true;
            }
            return false;
        })
    }

    public getByWebsiteId(websiteId: string): IImage[] {
        return filter(this.list, { websiteId: websiteId });
    }

    public removeById(id: string) {
        this.list = filter(this.list, item => {
            if (item.id != id) {
                return true;
            }
            return false;
        })
    }

    constructor() {
        makeObservable(this, {
            list: observable,
            addRecords: action,
            removeById: action,
        })
    }
}